/**
 * Central place to import AWS SDK and different API components
 */
import AWS from 'aws-sdk'
import apigClientFactory from 'aws-api-gateway-client'

import {userAccountRegister, userAccountUpdate} from './user'
import {userAddressRetrieve, userAddressUpdate} from './address'
import {userAddressServiceRetrieve, userAddressServiceUpdate} from './service'
import {sendMessage} from './message'

export {
  AWS,
  apigClientFactory,
  userAccountRegister,
  userAccountUpdate,
  userAddressRetrieve,
  userAddressUpdate,
  userAddressServiceRetrieve,
  userAddressServiceUpdate,
  sendMessage
}




// WEBPACK FOOTER //
// ./src/api/index.js